import React from 'react'
import styled, { keyframes } from 'styled-components';
import { merge, bounceOutDown, fadeOut, bounceInUp } from 'react-animations'
import Card from 'react-bootstrap/Card'
import Image from 'react-bootstrap/Image'
import { Default, Mobile } from './ViewTypes'
import moment from 'moment'
import Truncate from 'react-truncate'

const bounceAnimation = keyframes`${bounceInUp}`;

const BouncyDiv = styled.div`
  animation: 1.2s ${bounceAnimation};
`

const bounceOutAnimation = keyframes`${bounceOutDown}`;

const BounceOutDiv = styled.div`
  animation: 1.8s ${bounceOutAnimation};
`
const UNIVERSE = 'rgba(28,35,43,.15)'


export default class EventTelemetryOverlay extends React.Component { 

	constructor(props){ 
		super(props)
		this.state =  { 
			telemetryActive: false, 
  			telemetryHide: false, 
  			telemetryIndex: 0, 
  			telemetryTimerId: null
		}
	}

	componentDidMount() {
		setTimeout(() => { this.showTelemetry() }, 1000)
		this.startTelemetryAsync()
	}

	startTelemetryAsync() { 
		let timerId = setInterval(() => this.showTelemetry(), 8000);
		this.setState({telemetryTimerId: timerId})
	}

	hideTelemetry() { 
		const newIndex = this.state.telemetryIndex + 1
		const eventMaxTelemetry = this.props.eventTelemetry.length - 1 
		this.setState({telemetryActive: false, telemetryHide: false})
		if (newIndex > eventMaxTelemetry) { 
			setTimeout(() => { clearInterval(this.state.telemetryTimerId) }, 0);
		} else { 
			this.setState({telemetryIndex: newIndex})
		}
	}

	popOutTelemetry() { 
		this.setState({telemetryActive:true, telemetryHide: true})
		setTimeout(() => { this.hideTelemetry() }, 1000);
	}

	showTelemetry() { 
		this.setState({telemetryActive: true, telemetryHide: false})
		setTimeout(() => { this.popOutTelemetry() }, 3000);
	} 


	getTelemetryDiv()  {
		const telemetry = this.props.eventTelemetry[this.state.telemetryIndex]
		const body = <Card style={{boxShadow: ` 0px 0px 10px ${UNIVERSE}`}}>
					  <Card.Body>
					  <div style={{display: 'flex'}}>
						  <div>
						   <Image
						    	width={40}
						    	height={40}
						    	className="mr-3"
						    	src="/static/person.png"
						    	alt="Generic placeholder"
						  		roundedCircle
						  	/>
						  </div>
						  <div>
							  <p style={{marginBottom: 5, marginTop: 0, fontSize: 12}}>{telemetry.first_name}</p> 
							  	<p style={{marginBottom: 5, marginTop: 0, fontSize: 12}}>
							  		<Truncate lines={1}>
							  			got tickets to <strong> {this.props.eventName}</strong>
				      			</Truncate></p>
							  <p style={{marginBottom: 5, marginTop: 0, fontSize: 8}}>{moment(telemetry.created_at).startOf('minute').fromNow()}</p>
						  </div>
					  </div>

					  </Card.Body>
					</Card>
		const telemetryDivStyle = {position: 'absolute', width: '100%'}

		if (this.state.telemetryActive === true && this.state.telemetryHide === false) {
			return <BouncyDiv style={telemetryDivStyle}>
				{body}
			</BouncyDiv>
		} 

		if (this.state.telemetryActive === true && this.state.telemetryHide === true) { 
			return <BounceOutDiv style={telemetryDivStyle}>
			{body}
			</BounceOutDiv>
		} else { 
			return null
		}

	}

	render() { 
		if (this.state.telemetryActive == false || this.props.eventTelemetry.length === 0) { 
			return null
		}

		return (
			<div style={{zIndex: 10, position:'absolute'}}>
				<Default>
					<div style={defaultStyle}>
						{this.getTelemetryDiv()}
					</div>
				</Default>
				<Mobile>
					<div style={mobileStyle}>
						{this.getTelemetryDiv()}
					</div>
				</Mobile>
			</div>
			)

	}
}

const defaultStyle = {
				position: 'fixed', /* Sit on top of the page content */
  				width: '30%', /* Full width (cover the whole page) */
  				height: '10%', /* Full height (cover the whole page) */
  				bottom: '10%',
  				marginLeft:'2%',
  				left: 0,
  				backgroundCcolor: 'rgba(0,0,0,0.5)', /* Black background with opacity */
  				zIndex: 2, /* Specify a stack order in case you're using a different order for other elements */
  				cursor: 'pointer' /* Add a pointer on hover */
			}


const mobileStyle = { 
				position: 'fixed', /* Sit on top of the page content */
  				width: '100%', /* Full width (cover the whole page) */
  				height: '10%', /* Full height (cover the whole page) */
  				bottom: 20,
  				left: 0,
  				backgroundCcolor: 'rgba(0,0,0,0.5)', /* Black background with opacity */
  				zIndex: 2, /* Specify a stack order in case you're using a different order for other elements */
  				cursor: 'pointer' /* Add a pointer on hover */
			}
